import React from "react";
import {useTranslation} from "react-i18next";
import {useProductListContext} from "../ProductListProvider/ProductListProvider";
import styles from "./ProductList.module.scss";
import buttonStyles from "../../lib/form/Button/Button.module.scss";
import {Button, ButtonStyles, ButtonType} from "../../lib/form/Button/Button";
import Spinner from "../../utils/loader/Spinner";

/**
 * The component showing some user action buttons like
 * - 'show more': loads the next batch of items
 * - 'filter': an anchor to the top of the page, using the `setShowFilters` callback
 * - 'go to super category': link to the primary linked super category
 * @constructor
 */
const ListViewMoreButton: React.FC = () => {
  const {t} = useTranslation();
  const {state, dispatch} = useProductListContext();

  // If no further items
  if (state.isLastPage) {
    const sectionNode = document.querySelector<HTMLElement>(".product-list-react");
    const [url, title] = [sectionNode?.dataset.superCategoryUrl, sectionNode?.dataset.superCategoryTitle];

    // If category has primary super category, show link button
    if (url && title) {
      return (
        <div className={styles.viewMoreButtonContainer}>
          <a href={url} className={`${buttonStyles.buttonPrimary} ${buttonStyles.buttonBig}`}>
            {t("Alle {{title}} aufrufen", {title})}
          </a>
        </div>
      );
    } else {
      // Show nothing
      return null;
    }
  }

  // More items to come
  return (
    <>
      {/* Button to show more items */}
      <div className={styles.viewMoreButtonContainer}>
        <Button
          action={() => {
            dispatch({
              type: "VIEW_MORE",
            });
          }}
          styles={[ButtonStyles.big]}
          type={state.loading ? ButtonType.disabled : ButtonType.default}
        >
          {state.loading ? <Spinner /> : t("Mehr laden")}
        </Button>
      </div>
      {/* Button to jump back up to filters and to open them */}
      <div className={styles.viewMoreButtonContainer}>
        <a
          href={t("#produkte")}
          className={`${buttonStyles.buttonPrimary} ${buttonStyles.buttonBig} button-white`}
          onClick={() => dispatch({type: "SHOW_FILTERS", payload: true})}
        >
          {t("Filter")}
        </a>
      </div>
    </>
  );
};

export default ListViewMoreButton;
